import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/customers/$customerId/edit',
}).lazy(() => import('./$customerId.edit.lazy').then((d) => d.Route))
